import { Button } from "@/src/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/src/components/ui/dialog";
import { useContext, useState } from "react";
import { useFetch } from "@/src/lib/useFetch";
import { Option } from "../Options/model";
import { Input } from "@/src/components/ui/input";
import { SearchParamsContext } from "./search";

export type BMOnHoldButtonProps = {
  yachtId: string;
};
export function BMOnHoldButton(props: BMOnHoldButtonProps) {
  const [open, setOpen] = useState(false);
  const { fetch } = useFetch();

  const params = useContext(SearchParamsContext);

  const [clientName, setClientName] = useState("");

  const openDialog = async () => {
    const { data: y } = await fetch<{ data: { provider: string; externalId: string } }>(
      `/api/yachts/yacht/${props.yachtId}`,
    );

    if (y.provider !== "BM") {
      alert(`Options not implemented for provider ${y.provider}`);
    }

    setOpen(true);
  };

  const createOption = async () => {
    const { data: o } = await fetch<{ data: Option }>(`/api/options/options`, "POST", {
      yachtId: props.yachtId,
      createInApi: true,
      periodFrom: params.period!.dateFrom,
      periodTo: params.period!.dateTo,
      clientFirstName: clientName,
      clientLastName: "",
    });
    setOpen(false);
    setClientName("");
    window.open(
      `https://portal.booking-manager.com/wbm2/app/my_bookings/editor.jsp?companyid=2066&id=${o.externalId}`,
      "_blank",
    );
  };

  return (
    <Dialog open={open} onOpenChange={(b) => !b && setOpen(false)}>
      <DialogTrigger>
        <Button onClick={openDialog}>Put on hold</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle>Enter client info</DialogTitle>
        <Input placeholder="Client name" value={clientName} onChange={(e) => setClientName(e.target.value)} />
        <Button onClick={createOption}>Create option</Button>
      </DialogContent>
    </Dialog>
  );
}
